import { useState } from 'react';
import SearchForm from './SearchForm';
import ResultsBox from './ResultsBox';
import ErrorBox from './ErrorBox';
import SearchResults from '../../entities/SearchResults';
import Inventory from '../../entities/Inventory';
import style from './Search.module.css';
import { translate } from '../../helpers/translations';

interface SearchPropsInterface {
  onSearch: (searchTerm: string) => Promise<SearchResults | null>;
  onSelectInventory: (inventory: Inventory) => Promise<void>;
}

export default function Search(props: SearchPropsInterface) {
  const { onSearch, onSelectInventory } = props;
  const emptySearchResults = new SearchResults();
  const [term, setTerm] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState<SearchResults>(emptySearchResults);
  const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

  const closeResultsBox = () => setHasBeenSubmitted(false);
  const closeErrorBox = () => setError('');

  const handleSubmit = async (submittedSearchTerm: string) => {
    setError('');
    setSearchResults(emptySearchResults);
    setHasBeenSubmitted(false);

    if (submittedSearchTerm === '') {
      setError(translate('LYT_SECONDHAND_PLEASE_ENTER_SEARCH_TERM'));
      return;
    }

    setLoading(true);

    try {
      const newSearchResults = await onSearch(submittedSearchTerm);

      if (newSearchResults === null) {
        return;
      }

      setHasBeenSubmitted(true);
      setSearchResults(newSearchResults);
      setLoading(false);
    } catch (err) {
      setError('Something went wrong when searching.');
      setHasBeenSubmitted(false);
      setLoading(false);
    }
  };

  const handleTermChange = (submittedSearchTerm: string) => {
    if (submittedSearchTerm === '' && searchResults.getSearchResults().length === 0) {
      setHasBeenSubmitted(false);
    }

    setTerm(submittedSearchTerm);
  };

  const handleSelectInventory = async (inventory: Inventory) => {
    setError('');
    await onSelectInventory(inventory);
  };

  return (
    <div className={style.container}>
      <SearchForm
        term={term ?? ''}
        onSubmit={handleSubmit}
        onSearchTermChanged={handleTermChange}
        loading={loading}
      />
      <ResultsBox
        results={searchResults}
        hasBeenSubmitted={hasBeenSubmitted}
        onInventorySelected={handleSelectInventory}
        onClose={closeResultsBox}
        loading={loading}
      />
      <ErrorBox
        error={error}
        onClose={closeErrorBox}
      />
    </div>
  );
}
